import { createContext, useContext } from 'react';

export const SelectCloseContext = createContext<(() => void) | null>(null);
export const SelectOpenContext = createContext(false);

export function useSelectClose() {
  return useContext(SelectCloseContext);
}

export function useSelectOpen() {
  return useContext(SelectOpenContext);
}
